"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordProviders = void 0;
exports.PasswordProviders = {
    Whoop: "whoop",
    Renpho: "renpho",
    Peloton: "peloton",
    Zwift: "zwift",
    EightSleep: "eight_sleep",
    BeurerApi: "beurer_api",
    Dexcom: "dexcom",
    Hammerhead: "hammerhead",
    MyFitnessPal: "my_fitness_pal",
    Kardia: "kardia",
};
